import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/queryKeys";
import { borrowerService } from "@/services/borrowers";

export function useAssignUnderwriter() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ borrowerId, underwriterId }: { borrowerId: number; underwriterId: number }) =>
      borrowerService.assignUnderwriter(borrowerId, underwriterId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.borrowers() });
    },
  });
}
